<template>
  <grid
    :gridConfigUrl="gridConfigUrl">
  </grid>
</template>
<script>
  import Grid from './grid.vue'
  export default {
    components: {
      Grid
    },
    name: 'common-grid',
    data() {
      return {
        gridConfigUrl: ''
      }
    },
    created() {
      this.gridConfigUrl = this.$route.meta.url
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/grid/common-grid.vue